import { styled } from '@mui/material';

import { ReactNode } from 'react';

const StyledTabPanel = styled('div')<{ hidden: boolean }>(
  ({ theme, hidden }) => ({
    display: hidden ? 'none' : 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    minHeight: theme.spacing(100),
  })
);

export type PersonaFormTabPanelProps = {
  hidden: boolean;
  children: ReactNode;
};

export const PersonaFormTabPanel = ({
  hidden,
  children,
}: PersonaFormTabPanelProps) => {
  return <StyledTabPanel hidden={hidden}>{children}</StyledTabPanel>;
};
